const RequiredFieldsLegend = ({ className = '' }: { className?: string }) => (
    <p className={`text-xs text-muted-foreground ${className}`}>
        Les champs marqués d'un <sup className="text-destructive">*</sup> sont obligatoires.
    </p>
);

export default RequiredFieldsLegend;
